import { navLinks } from "@/mocks/home";

const footNav = [
  {
    title: "板块",
    links: [
      { label: "影视剧综", href: "#topics" },
      { label: "明星八卦", href: "#topics" },
      { label: "互联网观察", href: "#topics" },
      { label: "生活热梗", href: "#topics" },
    ],
  },
  {
    title: "快速了解",
    links: [
      { label: "热议榜单", href: "#hot" },
      { label: "争议观察", href: "#debate" },
      { label: "讨论指南", href: "#guide" },
      { label: "常见问题", href: "#guide" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-300 bg-background-200">
      <div className="mx-auto w-full max-w-7xl px-4 pb-8 pt-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5" aria-label="宿野吃瓜 回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-white">
                <i className="ri-chat-heart-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-display text-2xl leading-none tracking-wide text-foreground-950">
                宿野<span className="text-primary-600">吃瓜</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              汇集各路瓜友热评、观点与争议焦点的中文吃瓜讨论社区。客观呈现多方视角，理性碰撞不同声音，帮你快速了解舆论风向。
            </p>
            <nav className="mt-5 flex flex-wrap gap-2" aria-label="页脚导航">
              {navLinks.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  className="whitespace-nowrap rounded-full bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:text-primary-600"
                >
                  {l.label}
                </a>
              ))}
            </nav>
          </div>

          {footNav.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-950">{col.title}</h4>
              <ul className="mt-3 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <p className="mt-8 border-t border-background-300 pt-5 text-xs leading-relaxed text-foreground-600">
          免责声明：宿野吃瓜为观点聚合与讨论社区，站内热评与动态内容仅代表发言用户个人观点，不代表平台立场，亦不对未经证实的传闻作出定论。请理性吃瓜、依法发言。
        </p>

        <div className="mt-5 flex flex-col items-center justify-between gap-3 border-t border-background-300 pt-5 sm:flex-row">
          <p className="text-xs text-foreground-600">
            © {new Date().getFullYear()} 宿野吃瓜 · 让观点流动，也让秩序在场
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="mailto:feedback@suye-chigua.example" className="transition-colors hover:text-primary-600">
              联系我们
            </a>
            <a href="#guide" className="transition-colors hover:text-primary-600">
              讨论规范
            </a>
            <a href="#about" className="transition-colors hover:text-primary-600">
              关于我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}